export interface RefreshLimitPauseAlert {
  candidateId: string;
  slotId: string;
  candidateName: string;
  assessmentName?: string;
  /** Deliberate-reload count at the moment of the pause. Display only, never the gate. */
  refreshCount?: number;
  pausedAt: string;
}

export interface ExamPausedOnRefreshLimitPayload {
  candidateId: string;
  slotId: string;
  candidateName: string;
  assessmentName?: string;
  refreshCount?: number;
  pausedAt: string;
}

export interface RefreshLimitPauseResolvedPayload {
  candidateId: string;
  slotId: string;
}

/** Map key for deduplicating alerts in React state. */
export const getRefreshLimitPauseAlertKey = (candidateId: string, slotId: string) =>
  `${candidateId}-${slotId}`;

/**
 * localStorage key for a pending refresh-limit pause.
 * Distinct prefix from windowReset_ so the two alert kinds can't restore each other's entries.
 */
export const getRefreshLimitPauseLocalStorageKey = (slotId: string, candidateId: string) =>
  `refreshLimitPause_${slotId}_${candidateId}`;
